/**
 * Renders a Spotify iframe for an album, artist, track, or playlist.
 * Pass exactly one of: albumId, artistId, trackId, playlistId
 */
export default function SpotifyEmbed({ albumId, artistId, trackId, playlistId, title = "Stream" }) {
  let path = null;
  let id = null;
  if (albumId) { path = "album"; id = albumId; }
  else if (artistId) { path = "artist"; id = artistId; }
  else if (trackId) { path = "track"; id = trackId; }
  else if (playlistId) { path = "playlist"; id = playlistId; }
  if (!path) return null;

  // Artist embeds need taller iframe to fit top tracks
  const height = path === "artist" ? 380 : 352;

  return (
    <div className="my-10" data-testid={`spotify-embed-${path}-${id}`}>
      <div className="label text-pfc-gold mb-3">▶ {title}</div>
      <iframe
        title={`Spotify ${path} ${id}`}
        src={`https://open.spotify.com/embed/${path}/${id}?utm_source=generator&theme=0`}
        width="100%"
        height={height}
        frameBorder="0"
        allowFullScreen=""
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
        style={{ borderRadius: 12 }}
        className="w-full"
      />
    </div>
  );
}
